import React from 'react';

interface Props {
  className?: string;
  label: string;
}

export const BetaBadge = ({ label, className }: Props): JSX.Element => {
  return (
    <span
      className={`inline-flex items-center rounded-full bg-sapphire-50 px-2.5 py-0.5 text-xs font-semibold text-sapphire-700${className ? ` ${className}` : ''}`}
    >
      {label}
    </span>
  );
};
